// eslint-disable-next-line no-restricted-imports
import {
  OnboardingProcessFragment,
  Query_ClientController_GetById_Representative_Onboarding_Process_CurrentStep_Name as StepNameApi,
} from 'api/generated/graphql';
import {
  OnboardingProcessEntity,
  OnboardingProcessStepNameType,
} from 'api/types/entity';
import { lodash } from 'helpers';

const stepMap: Record<StepNameApi, OnboardingProcessStepNameType> = {
  [StepNameApi.ClientAddresses]: OnboardingProcessStepNameType.ClientAddresses,
  [StepNameApi.ClientBankAccounts]:
    OnboardingProcessStepNameType.ClientBankAccounts,
  [StepNameApi.ClientBiography]: OnboardingProcessStepNameType.ClientBiography,
  [StepNameApi.ClientCitizenships]:
    OnboardingProcessStepNameType.ClientCitizenships,
  [StepNameApi.ClientConfirmDataAccuracy]:
    OnboardingProcessStepNameType.ClientConfirmDataAccuracy,
  [StepNameApi.ClientDebts]: OnboardingProcessStepNameType.ClientDebts,
  [StepNameApi.ClientFinancingSources]:
    OnboardingProcessStepNameType.ClientFinancingSources,
  [StepNameApi.ClientKyc]: OnboardingProcessStepNameType.ClientKyc,
  [StepNameApi.ClientOrderSubmissionContacts]:
    OnboardingProcessStepNameType.ClientOrderSubmissionContacts,
  [StepNameApi.ClientPep]: OnboardingProcessStepNameType.ClientPep,
  [StepNameApi.ClientSignatureCards]:
    OnboardingProcessStepNameType.ClientSignatureCards,
  [StepNameApi.ClientTaxResidencies]:
    OnboardingProcessStepNameType.ClientTaxResidencies,
  [StepNameApi.ClientSigningDocuments]:
    OnboardingProcessStepNameType.ClientSigningDocuments,
  [StepNameApi.ClientSigningQuestionnaire]:
    OnboardingProcessStepNameType.ClientSigningQuestionnaire,
  [StepNameApi.ClientSigningServiceContract]:
    OnboardingProcessStepNameType.ClientSigningContract,
  [StepNameApi.ClientBusinessRelationship]:
    OnboardingProcessStepNameType.ClientBusinessRelationship,
  [StepNameApi.ClientWithdrawalAccounts]:
    OnboardingProcessStepNameType.ClientWithdrawalAccounts,
  [StepNameApi.ClientRiskProfile]:
    OnboardingProcessStepNameType.ClientRiskProfile,
  [StepNameApi.ClientFinancialPosition]:
    OnboardingProcessStepNameType.ClientFinancialPosition,
  [StepNameApi.ClientW8BenForm]: OnboardingProcessStepNameType.ClientW8BENForm,
  [StepNameApi.ClientIncomeSource]:
    OnboardingProcessStepNameType.ClientSourcesOfIncome,
  [StepNameApi.ClientKnowledgeAndExperience]:
    OnboardingProcessStepNameType.ClientKnowledgeAndExperience,
  [StepNameApi.ClientInvoice]: OnboardingProcessStepNameType.ClientInvoice,
  [StepNameApi.ClientInvoicePaymentConfirmationFiles]:
    OnboardingProcessStepNameType.ClientInvoicePaymentConfirmationFiles,
  [StepNameApi.ClientRepresentativeAddresses]:
    OnboardingProcessStepNameType.ClientRepresentativeAddresses,
  [StepNameApi.ClientRepresentativeBankAccounts]:
    OnboardingProcessStepNameType.ClientRepresentativeBankAccounts,
  [StepNameApi.ClientRepresentativeBiography]:
    OnboardingProcessStepNameType.ClientRepresentativeBiography,
  [StepNameApi.ClientRepresentativeCitizenships]:
    OnboardingProcessStepNameType.ClientRepresentativeCitizenships,
  [StepNameApi.ClientRepresentativeCreateClient]:
    OnboardingProcessStepNameType.ClientRepresentativeCreateClient,
  [StepNameApi.ClientRepresentativeDebts]:
    OnboardingProcessStepNameType.ClientRepresentativeDebts,
  [StepNameApi.ClientRepresentativeKyc]:
    OnboardingProcessStepNameType.ClientRepresentativeKyc,
  [StepNameApi.ClientRepresentativePep]:
    OnboardingProcessStepNameType.ClientRepresentativePep,
  [StepNameApi.ClientRepresentativeBasisForRepresentation]:
    OnboardingProcessStepNameType.ClientRepresentativeBasisForRepresentation,
  [StepNameApi.ClientRepresentativeTaxResidencies]:
    OnboardingProcessStepNameType.ClientRepresentativeTaxResidencies,
  [StepNameApi.LegalClientBeneficiaryAddresses]:
    OnboardingProcessStepNameType.LegalClientBeneficiaryAddresses,
  [StepNameApi.LegalClientBeneficiaryCitizenships]:
    OnboardingProcessStepNameType.LegalClientBeneficiaryCitizenships,
  [StepNameApi.LegalClientBeneficiaryControlOverLegalClient]:
    OnboardingProcessStepNameType.LegalClientBeneficiaryControlOverLegalClient,
  [StepNameApi.LegalClientBeneficiaryPep]:
    OnboardingProcessStepNameType.LegalClientBeneficiaryPep,
  [StepNameApi.LegalClientBeneficiaryPersonalData]:
    OnboardingProcessStepNameType.LegalClientBeneficiaryPersonalData,
  [StepNameApi.LegalClientBeneficiaryTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientBeneficiaryTaxResidencies,
  [StepNameApi.LegalClientBranchAddresses]:
    OnboardingProcessStepNameType.LegalClientBranchAddresses,
  [StepNameApi.LegalClientBranchContacts]:
    OnboardingProcessStepNameType.LegalClientBranchContacts,
  [StepNameApi.LegalClientBranchName]:
    OnboardingProcessStepNameType.LegalClientBranchName,
  [StepNameApi.LegalClientBranchStateRegistration]:
    OnboardingProcessStepNameType.LegalClientBranchStateRegistration,
  [StepNameApi.LegalClientBranchTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientBranchTaxResidencies,
  [StepNameApi.LegalClientHeadAddresses]:
    OnboardingProcessStepNameType.LegalClientHeadAddresses,
  [StepNameApi.LegalClientHeadCitizenships]:
    OnboardingProcessStepNameType.LegalClientHeadCitizenships,
  [StepNameApi.LegalClientHeadPep]:
    OnboardingProcessStepNameType.LegalClientHeadPep,
  [StepNameApi.LegalClientHeadPersonalData]:
    OnboardingProcessStepNameType.LegalClientHeadPersonalData,
  [StepNameApi.LegalClientHeadTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientHeadTaxResidencies,
  [StepNameApi.LegalClientHeadPosition]:
    OnboardingProcessStepNameType.LegalClientHeadPosition,
  [StepNameApi.LegalClientLegalHeadFirstHeadAddresses]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadAddresses,
  [StepNameApi.LegalClientLegalHeadFirstHeadCitizenships]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadCitizenships,
  [StepNameApi.LegalClientLegalHeadFirstHeadPep]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPep,
  [StepNameApi.LegalClientLegalHeadFirstHeadPersonalData]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPersonalData,
  [StepNameApi.LegalClientLegalHeadFirstHeadPositionInCompany]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPositionInCompany,
  [StepNameApi.LegalClientLegalHeadFirstHeadTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadTaxResidencies,
  [StepNameApi.LegalClientLegalHeadFirstHeadIdentityDocument]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadIdentityDocument,
  [StepNameApi.LegalClientLegalHeadAddresses]:
    OnboardingProcessStepNameType.LegalClientLegalHeadAddresses,
  [StepNameApi.LegalClientLegalHeadCompanyName]:
    OnboardingProcessStepNameType.LegalClientLegalHeadCompanyName,
  [StepNameApi.LegalClientLegalHeadFirstHeads]:
    OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeads,
  [StepNameApi.LegalClientLegalHeadStateRegistration]:
    OnboardingProcessStepNameType.LegalClientLegalHeadStateRegistration,
  [StepNameApi.LegalClientLegalHeadTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientLegalHeadTaxResidencies,
  [StepNameApi.LegalClientLegalHeadPosition]:
    OnboardingProcessStepNameType.LegalClientLegalHeadPosition,
  [StepNameApi.LegalClientLegalHeadOrganizationalAndLegalForm]:
    OnboardingProcessStepNameType.LegalClientLegalHeadOrganizationalAndLegalForm,
  [StepNameApi.LegalClientRepresentativeAddresses]:
    OnboardingProcessStepNameType.LegalClientRepresentativeAddresses,
  [StepNameApi.LegalClientRepresentativeBiography]:
    OnboardingProcessStepNameType.LegalClientRepresentativeBiography,
  [StepNameApi.LegalClientRepresentativeCitizenships]:
    OnboardingProcessStepNameType.LegalClientRepresentativeCitizenships,
  [StepNameApi.LegalClientRepresentativeCompanyAddresses]:
    OnboardingProcessStepNameType.LegalClientRepresentativeCompanyAddresses,
  [StepNameApi.LegalClientRepresentativeCompanyConstitutionalDocument]:
    OnboardingProcessStepNameType.LegalClientRepresentativeCompanyConstitutionalDocument,
  [StepNameApi.LegalClientRepresentativeCompanyName]:
    OnboardingProcessStepNameType.LegalClientRepresentativeCompanyName,
  [StepNameApi.LegalClientRepresentativeCompanyStateRegistration]:
    OnboardingProcessStepNameType.LegalClientRepresentativeCompanyStateRegistration,
  [StepNameApi.LegalClientRepresentativeCompanyTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientRepresentativeCompanyTaxResidencies,
  [StepNameApi.LegalClientRepresentativeKyc]:
    OnboardingProcessStepNameType.LegalClientRepresentativeKyc,
  [StepNameApi.LegalClientRepresentativePep]:
    OnboardingProcessStepNameType.LegalClientRepresentativePep,
  [StepNameApi.LegalClientRepresentativeRoleInCompany]:
    OnboardingProcessStepNameType.LegalClientRepresentativeRoleInCompany,
  [StepNameApi.LegalClientRepresentativeTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientRepresentativeTaxResidencies,
  [StepNameApi.LegalClientActivityTypes]:
    OnboardingProcessStepNameType.LegalClientActivityTypes,
  [StepNameApi.LegalClientAddresses]:
    OnboardingProcessStepNameType.LegalClientAddresses,
  [StepNameApi.LegalClientBankAccounts]:
    OnboardingProcessStepNameType.LegalClientBankAccounts,
  [StepNameApi.LegalClientBeneficiaries]:
    OnboardingProcessStepNameType.LegalClientBeneficiaries,
  [StepNameApi.LegalClientBodies]:
    OnboardingProcessStepNameType.LegalClientBodies,
  [StepNameApi.LegalClientBranches]:
    OnboardingProcessStepNameType.LegalClientBranches,
  [StepNameApi.LegalClientBusinessRelationship]:
    OnboardingProcessStepNameType.LegalClientBusinessRelationship,
  [StepNameApi.LegalClientConfirmDataAccuracy]:
    OnboardingProcessStepNameType.LegalClientConfirmDataAccuracy,
  [StepNameApi.LegalClientConstitutionalDocument]:
    OnboardingProcessStepNameType.LegalClientConstitutionalDocument,
  [StepNameApi.LegalClientContacts]:
    OnboardingProcessStepNameType.LegalClientContacts,
  [StepNameApi.LegalClientDebts]:
    OnboardingProcessStepNameType.LegalClientDebts,
  [StepNameApi.LegalClientFinancialMonitoring]:
    OnboardingProcessStepNameType.LegalClientFinancialMonitoring,
  [StepNameApi.LegalClientFinancingSources]:
    OnboardingProcessStepNameType.LegalClientFinancingSources,
  [StepNameApi.LegalClientHeads]:
    OnboardingProcessStepNameType.LegalClientHeads,
  [StepNameApi.LegalClientInvoice]:
    OnboardingProcessStepNameType.LegalClientInvoice,
  [StepNameApi.LegalClientInvoicePaymentConfirmationFiles]:
    OnboardingProcessStepNameType.LegalClientInvoicePaymentConfirmationFiles,
  [StepNameApi.LegalClientLicenseInfo]:
    OnboardingProcessStepNameType.LegalClientLicenseInfo,
  [StepNameApi.LegalClientOrderSubmissionContacts]:
    OnboardingProcessStepNameType.LegalClientOrderSubmissionContacts,
  [StepNameApi.LegalClientOrganizationalAndLegalForm]:
    OnboardingProcessStepNameType.LegalClientOrganizationalAndLegalForm,
  [StepNameApi.LegalClientOwnershipStructure]:
    OnboardingProcessStepNameType.LegalClientOwnershipStructure,
  [StepNameApi.LegalClientRegistrationPlace]:
    OnboardingProcessStepNameType.LegalClientRegistrationPlace,
  [StepNameApi.LegalClientSignatureCards]:
    OnboardingProcessStepNameType.LegalClientSignatureCards,
  [StepNameApi.LegalClientStateRegistration]:
    OnboardingProcessStepNameType.LegalClientStateRegistration,
  [StepNameApi.LegalClientTaxResidencies]:
    OnboardingProcessStepNameType.LegalClientTaxResidencies,
  [StepNameApi.LegalClientWithdrawalAccounts]:
    OnboardingProcessStepNameType.LegalClientWithdrawalAccounts,
  [StepNameApi.LegalClientCompanyName]:
    OnboardingProcessStepNameType.LegalClientCompanyName,
  [StepNameApi.LegalClientSigningQuestionnaire]:
    OnboardingProcessStepNameType.LegalClientSigningQuestionnaire,
  [StepNameApi.LegalClientIdentificationNumbers]:
    OnboardingProcessStepNameType.LegalClientIdentificationNumbers,
  [StepNameApi.LegalClientActivity]:
    OnboardingProcessStepNameType.LegalClientActivity,
  [StepNameApi.LegalClientKnowledgeAndExperience]:
    OnboardingProcessStepNameType.LegalClientKnowledgeAndExperience,
  [StepNameApi.LegalClientTargetedFinancialInstruments]:
    OnboardingProcessStepNameType.LegalClientTargetedFinancialInstruments,
  [StepNameApi.LegalClientInvestmentPurposeAndNature]:
    OnboardingProcessStepNameType.LegalClientInvestmentPurposeAndNature,
  [StepNameApi.LegalClientIncomeSources]:
    OnboardingProcessStepNameType.LegalClientSourcesOfIncome,
  [StepNameApi.LegalClientW8BenForm]:
    OnboardingProcessStepNameType.LegalClientW8BenForm,
  [StepNameApi.LegalClientFinancialMonitoringPartOne]:
    OnboardingProcessStepNameType.LegalClientFinancialMonitoringPartOne,
  [StepNameApi.LegalClientFinancialMonitoringPartTwo]:
    OnboardingProcessStepNameType.LegalClientFinancialMonitoringPartTwo,
  [StepNameApi.LegalClientSigningServiceContractGlobal]:
    OnboardingProcessStepNameType.LegalClientSigningServiceContract_Global,
  [StepNameApi.LegalClientSigningDocumentsFinance]:
    OnboardingProcessStepNameType.LegalClientSigningDocuments_Finance,
};

export const parseOnboardingProcessEntity = (
  process: OnboardingProcessFragment | undefined | null
): OnboardingProcessEntity | undefined =>
  process
    ? {
        currentStep: {
          isEditable: process.currentStep.isEditable,
          isEnabled: process.currentStep.isEnabled,
          name: stepMap[process.currentStep.name],
        },
        previousSteps: lodash
          .compact(process.previousSteps)
          .map((previousStep) => ({
            isCompleted: previousStep.isCompleted,
            isEditable: previousStep.isEditable,
            isEnabled: previousStep.isEnabled,
            name: stepMap[previousStep.name],
          })),
        totalStepCount: process.totalStepCount,
      }
    : undefined;
